module.exports = "/static/images/LJN.png";